// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__0+fU5","input_search":"style_input_search__3p3UH","btn_search":"style_btn_search__XPMKO","btn_w":"style_btn_w__j0ef1","bs_icon":"style_bs_icon__vkEPF"};